import Wrapper from '../shared/Wrapper'
import { PriceCard } from '../v2-landing-page/Pricing'

export default function Pricing(): JSX.Element {
  return (
    <Wrapper className="flex flex-col md:flex-row justify-between items-center gap-8 py-20">
      <div className="flex-1">
        <h1 className="text-2xl lg:text-4xl lg:leading-snug font-semibold mb-6">
          Ready to feel great?
        </h1>

        <p className="text-lg text-white text-opacity-40">
          Try Sukha for yourself and see what it’s like to blaze through your
          Tasks in record time
        </p>
      </div>

      {/*<PriceCard plan="free" />*/}
      <PriceCard plan="pro" />
    </Wrapper>
  )
}
